import React, { useRef, useState } from 'react';
import styles from '../modal.module.css';
import { Box, Button, IconButton, InputAdornment, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import * as api from '../../../pages/services/api';
import Loader from 'components/Loader';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import add from '../../../assets/icons/e-learning/add_back.svg';
import del from '../../../assets/icons/e-learning/delete_red.svg';

function ModalReplyMessage({ onClose, contactCode, onRefresh }) {
    const fileRef = useRef([]);
    const [loading, setLoading] = useState(false)

    const [message, setMessage] = useState('')
    const [attachment, setAttachment] = useState([
        // {
        //     fieldname: '',
        //     originalname: '',
        //     encoding: '',
        //     mimetype: '',
        //     destination: '',
        //     filename: '',
        //     path: '',
        //     size: '',
        //     url: ''
        // }
        {
            file_path: '',
            file_source: '',
            file_name: '',
            bucket_name: '',
            original_name: '',
            mime_type: '',
            size: '',
            file_api_url: '',
            file_access_url: ''
        }
    ])
    const handleButtonClickFile = (index) => {
        fileRef.current[index].click();
    }
    const handleFileChangeFlie = async (e, idx) => {
        // const file = e.target.files && e.target.files[0];
        // if (!file) return

        // let formData = new FormData()
        // formData.append('file', file)

        // setLoading(true)
        // let res = await api.uploadFile2('contact', formData)
        // setLoading(false)
        // if (res) {
        //     if (res['data']['code'] === 200) {
        //         let data = res['data']['data']

        //         let newAttachment = [...attachment];
        //         newAttachment[idx] = data;
        //         setAttachment(newAttachment);
        //     } else {
        //         //alert(res['data']['message'])
        //     }
        // } else {
        //     alert('ไม่ตอบสนอง')
        // }
        const file = e.target.files && e.target.files[0];
        if (!file) return

        let formData = new FormData()
        formData.append('file', file)
        formData.append('file_path', `/contact`)
        formData.append('file_source', 'contact')
        formData.append('file_name', file.name)

        setLoading(true)
        let res = await api.uploadFileImage('contact', formData)
        setLoading(false)
        if (!res) return alert('ไม่ตอบสนอง')

        const code = res['code']
        if (code === 200) {
            let newAttachment = [...attachment];
            newAttachment[idx] = res['data'];
            setAttachment(newAttachment);
        } else if (code === 403) {
            alert('ติดต่อสื่อสาร รองรับไฟล์เฉพาะ .pdf, .docx, .xlsx, .ppt, .pptx, .jpeg, .jpg, .png, .txt เท่านั้น')
        } else {
            console.log('error', res)
            alert('ไม่ตอบสนอง')
        }
    }

    const handClickDeleteAttachment = (index, i) => {
        attachment.splice(index, 1)
        setAttachment([...attachment])
    }

    const handleClickAddFile = () => {
        attachment.push({
            file_path: '',
            file_source: '',
            file_name: '',
            bucket_name: '',
            original_name: '',
            mime_type: '',
            size: '',
            file_api_url: '',
            file_access_url: ''
        })
        setAttachment([...attachment])
    }

    const handleButtonClickReply = () => {
        let body = {
            "contact_code": contactCode,
            "message": message,
            "message_attachment_file": attachment
        }
        // console.log(body)
        contactMessage(body)
    }

    const contactMessage = async (data) => {
        setLoading(true)
        let res = await api.contactMessage(data)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                //alert(res['data']['message'])
                onClose()
                onRefresh()
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal2}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>ตอบกลับ</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={() => { onClose() }}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'grid', gridGap: '10px' }}>
                        <Box>
                            <Box sx={{ fontWeight: 500 }}>รายละเอียด</Box>
                            <TextField
                                size='small'
                                fullWidth
                                multiline
                                rows={4}
                                placeholder='อธิบายที่นี่...'
                                name='message'
                                value={message}
                                onChange={(e) => { setMessage(e.target.value) }}
                            />
                        </Box>
                        <Box sx={{ display: 'grid', gridGap: '10px' }}>
                            <Box sx={{ display: 'flex', gridGap: '10px' }}>
                                <Box>แนบไฟล์</Box>
                                <img style={{ width: '20px' }} src={add} onClick={() => { handleClickAddFile() }} />
                            </Box>
                            {attachment.map((i, idx) => (
                                <Box sx={{ display: 'grid', gridTemplateColumns: '11fr 30px', gridGap: '5px' }}>
                                    <Box>
                                        <TextField
                                            fullWidth
                                            size='small'
                                            id='file-upload'
                                            placeholder='แนบไฟล์'
                                            onClick={() => handleButtonClickFile(idx)}
                                            value={i['file_name']}
                                            slotProps={{
                                                input: {
                                                    readOnly: true,
                                                    startAdornment: <InputAdornment position='start'><AttachFileIcon /></InputAdornment>
                                                }
                                            }}
                                        />
                                        <input
                                            id='file-upload'
                                            type="file"
                                            accept=".pdf,.docx,.xlsx,.ppt,.pptx,.jpeg,.jpg,.png,.txt"
                                            ref={el => fileRef.current[idx] = el}
                                            onChange={(event) => {
                                                handleFileChangeFlie(event, idx)
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img src={del} style={{ width: '20px' }} onClick={() => { handClickDeleteAttachment(idx) }} />
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button variant='contained' onClick={() => { handleButtonClickReply() }}>ส่ง</Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default ModalReplyMessage
